export default __webpack_public_path__ + "static/carousell-os-car-valuation-75k-bids-received-e9ac2e9947ba01b60880c015c7219cd3.svg";